/**
 * videoaulaBuilder — Videoaulas (Material Didático — vídeo por URL), BE módulo content.
 *
 * @since fase material-didático videoaula (2026-07-16)
 */
import type { $Fetch } from 'ofetch';

import { HttpVideoaulaGateway } from '@/infrastructure/http/HttpVideoaulaGateway';
import {
  ListVideoaulas, CreateVideoaula, UpdateVideoaula, ArquivarVideoaula,
} from '@/application/usecase/VideoaulaUseCaseImpl';

export function buildVideoaulaSlice(httpClient: $Fetch) {
  const gateway = new HttpVideoaulaGateway(httpClient);

  const useCases = {
    listVideoaulas: new ListVideoaulas(gateway),
    createVideoaula: new CreateVideoaula(gateway),
    updateVideoaula: new UpdateVideoaula(gateway),
    arquivarVideoaula: new ArquivarVideoaula(gateway),
  };

  return { useCases };
}
